module.exports = __webpack_public_path__ + "static/media/faq_green-01.609e8b55.svg";